const ALPHABET =
  '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
const ID_LENGTH = 8

function generateID() {
  let rtn = ''
  for (let i = 0; i < ID_LENGTH; i += 1) {
    rtn += ALPHABET.charAt(Math.floor(Math.random() * ALPHABET.length))
  }
  return rtn
}

const EventName = {
  NATIVE_ASYNC: 'native_async'
}

const windowDispatchEvent = (eName, payload) => {
  const ev = new CustomEvent(eName, { detail: payload })
  window.dispatchEvent(ev)
}

const callbackResolves = {}

window.nativeCallback = function nativeCallback(uid, ret) {
  if (uid in callbackResolves) {
    document.body.removeChild(callbackResolves[uid].node)
    callbackResolves[uid].resolve(ret)
  } else {
    const iframeCallback = document.getElementsByTagName('iframe')[0].contentWindow.nativeCallback
    if (iframeCallback) {
      iframeCallback(uid, ret)
    } else {
      alert(`uid miss ${uid}`)
      console.error(`uid miss ${uid}`)
    }
  }
}

export const callNativeAsyncFunc = (f, param = '') => {
  return new Promise((resolve) => {
    const uid = generateID()
    const mIframe = document.createElement('iframe')
    callbackResolves[uid] = { resolve, node: mIframe }
    const prm = typeof param === 'object' ? JSON.stringify(param) : param
    const src = `native-asyn::${f.ns}::${f.fn}::${uid}::${prm}`
    mIframe.src = src
    mIframe.name = 'native_request'
    // 设置样式
    mIframe.style.display = 'none'
    mIframe.style.width = '0'
    mIframe.style.height = '0'
    document.body.appendChild(mIframe)
    windowDispatchEvent(EventName.NATIVE_ASYNC, {
      ...param,
      src,
      uid,
      ns: f.ns,
      fn: f.fn
    })
  })
}

export const NativeFuncs = {
  NAVIGATION: {
    CUSTOMER_SERVICE: {
      ns: 'navigation',
      fn: 'customerService'
    },
    GENERAL: {
      ns: 'navigation',
      fn: 'general'
    }
  },
  INVENTORY: {
    INVENTORY_INFO: {
      ns: 'inventory',
      fn: 'inventoryInfo'
    },
    UNINVENTORY_INFO: {
      ns: 'inventory',
      fn: 'uninventoryInfo'
    },
    SEND_SUMMARY_SWITCH: {
      ns: 'inventory',
      fn: 'sendSummarySwitch'
    },
    SEND_INVENTORY_INFO: {
      ns: 'inventory',
      fn: 'sendInventoryInfo'
    },
    SEND_UNINVENTORY_INFO: {
      ns: 'inventory',
      fn: 'sendUninventoryInfo'
    }
  },
  SYSTEM: {
    APP_SHARE: {
      ns: 'system',
      fn: 'appShare'
    },
    USER_DATA: {
      ns: 'system',
      fn: 'userData'
    },
    IMAGE_BROWSER: {
      ns: 'system',
      fn: 'Imagebrowser'
    },
    ALERT: {
      ns: 'system',
      fn: 'alert'
    },
    WEBVIEW_ACTION: {
      ns: 'system',
      fn: 'webViewAction'
    },
    ENTRY_PARAM: {
      ns: 'system',
      fn: 'generalData'
    },
    REGISTER_CALLBACK: {
      ns: 'system',
      fn: 'registerCB'
    },
    SCAN_CODE: {
      ns: 'system',
      fn: 'scanCode'
    },
    STATUS_BAR_STYLE: {
      ns: 'system',
      fn: 'statusBarStyle'
    },
    CLOSE: {
      ns: 'system',
      fn: 'close'
    },
    BACK_BTN_CB: {
      ns: 'system',
      fn: 'backBtnCallback'
    },
    SAVE_IMAGE: {
      ns: 'system',
      fn: 'saveImage'
    },
    PAYMENT: {
      ns: 'system',
      fn: 'payment'
    },
    PAY: {
      ns: 'system',
      fn: 'pay'
    },
    VIEW_PURCHASE_ORDER: {
      ns: 'system',
      fn: 'viewPurchaseOrder'
    },
    GOTO_BATCH_EDIT: {
      ns: 'system',
      fn: 'goToBatchEdit'
    },
    ORDER_DETAIL: {
      ns: 'system',
      fn: 'orderDetail'
    },
    PROFITS_VIEW: {
      ns: 'system',
      fn: 'profitsView'
    },
    LOADING: {
      ns: 'system',
      fn: 'loading'
    },
    OPEN_WIDGET: {
      ns: 'system',
      fn: 'openWidget'
    },
    EVENT_TRACK: {
      ns: 'system',
      fn: 'eventTrack'
    },
    OPEN_WINDOW: {
      ns: 'system',
      fn: 'openWindow'
    },
    UPDATE_APP: {
      ns: 'system',
      fn: 'updateApp'
    },
    INIT_PAGE: {
      ns: 'system',
      fn: 'initPage'
    },
    SAVE_PICTURE: {
      ns: 'system',
      fn: 'savePicture'
    },
    PREVIEW_PICTURE: {
      ns: 'system',
      fn: 'previewPicture'
    },
    VIEW_SHIP_ORDER: {
      ns: 'system',
      fn: 'viewShipOrder'
    },
    GET_LOCAL_DEFAULT: {
      // 获取原生客户端的默认配置
      ns: 'system',
      fn: 'getLocalDefault'
    },
    RECOVERY_PENDING_ORDER: {
      ns: 'system',
      fn: 'recoveryPendingOrder'
    },
        EVENT_TRACK: {
      ns: 'system',
      fn: 'eventTrack'
    }
  },
  BHB: {
    INIT_BUHUOBAO_CATE_SELECTER: {
      ns: 'buhuobao',
      fn: 'initBuhuobaoCateSelecter'
    },
    CREATE_CATE: {
      ns: 'buhuobao',
      fn: 'creatCate'
    },
    NEW_CATE_DATA: {
      ns: 'buhuobao',
      fn: 'newCateData'
    },
    DID_SELECT_CATE: {
      ns: 'buhuobao',
      fn: 'didSelectCate'
    },
    GO_BUY_BUHUOBAO: {
      ns: 'buhuobao',
      fn: 'goBuyBuhuobao'
    },
    JUMP_TO_MINI_PROGRAM: {
      ns: 'mini',
      fn: 'jumpToMiniProgram'
    }
  },
  ALERT: {
    SHARE: {
      ns: 'alert',
      fn: 'share'
    }
  },
  // 报表
  REPORT: {
    DATA: {
      ns: 'report',
      fn: 'data'
    },
    SEND_DATA: {
      ns: 'report',
      fn: 'sendData'
    },
    LANDSCAPE: {
      ns: 'report',
      fn: 'landscape'
    },
    TOOLBAR: {
      ns: 'report',
      fn: 'toolbar'
    },
    ENTRANCE: {
      ns: 'report',
      fn: 'entrance'
    }
  }
}